const vivaProducts = new WeakSet();
const initVivaProducts = () => {
  document.querySelectorAll('.viva-pdp').forEach((pdp) => {
    if (vivaProducts.has(pdp)) return;
    vivaProducts.add(pdp);
    const heading = pdp.querySelector('.viva-pdp__heading');
    const siteHeader = document.getElementById('shopify-section-viva-shell-header');
    const updateStickyMeasurements = () => {
      pdp.style.setProperty('--viva-pdp-header-height', `${siteHeader?.getBoundingClientRect().height || 0}px`);
      pdp.style.setProperty('--viva-pdp-heading-height', `${heading?.getBoundingClientRect().height || 0}px`);
    };
    let headingFrame = 0;
    const updateHeadingSurface = () => {
      headingFrame = 0;
      if (!heading) return;
      const top = parseFloat(getComputedStyle(heading).top) || 0;
      heading.classList.toggle('is-stuck', window.scrollY > 0 && heading.getBoundingClientRect().top <= top + 1);
    };
    const scheduleHeadingSurface = () => {
      if (!headingFrame) headingFrame = requestAnimationFrame(updateHeadingSurface);
    };
    window.addEventListener('scroll', scheduleHeadingSurface, { passive: true });
    window.addEventListener('resize', scheduleHeadingSurface, { passive: true });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(pdp)) return;
      window.removeEventListener('scroll', scheduleHeadingSurface);
      window.removeEventListener('resize', scheduleHeadingSurface);
      cancelAnimationFrame(headingFrame);
    }, { once: true });
    updateStickyMeasurements();
    updateHeadingSurface();
    if ('ResizeObserver' in window) {
      const stickyObserver = new ResizeObserver(updateStickyMeasurements);
      if (siteHeader) stickyObserver.observe(siteHeader);
      if (heading) stickyObserver.observe(heading);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(pdp)) stickyObserver.disconnect();
      }, { once: true });
    }
    const gallery = window.initVivaProductVideo?.(pdp);
    const applyVariantImage = variant => gallery?.applyVariant(variant);

    const dataEl = pdp.querySelector('[data-pdp-variants]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    const currency = dataEl.getAttribute('data-pdp-currency') || 'PLN';
    const priceEl = pdp.querySelector('[data-pdp-price]');
    const idInput = pdp.querySelector('[data-pdp-variant-id]');
    const addBtn = pdp.querySelector('[data-pdp-add]');
    const askBtn = pdp.querySelector('[data-pdp-ask]');
    const addLabel = pdp.querySelector('[data-pdp-add-label]');
    const currentLabel = pdp.querySelector('[data-pdp-shade-current]');
    const lengthLabel = pdp.querySelector('[data-pdp-length-current]');
    const radios = pdp.querySelectorAll('[data-pdp-shade]');
    const lengthRadios = pdp.querySelectorAll('[data-pdp-length]');
    const typeRadios = pdp.querySelectorAll('[data-pdp-type]');
    const typeLabel = pdp.querySelector('[data-pdp-type-current]');
    const shadeIndex = Number(dataEl.dataset.pdpShadeIndex);
    const lengthIndex = Number(dataEl.dataset.pdpLengthIndex);
    const typeIndex = Number(dataEl.dataset.pdpTypeIndex);
    const highVariants = dataEl.dataset.pdpHighVariants === 'true';
    const selectionStatus = pdp.querySelector('[data-pdp-selection-status]');
    const swatches = pdp.querySelectorAll('.viva-pdp__swatch');
    const favBtn = pdp.querySelector('[data-fav-toggle]');
    const favBase = favBtn ? favBtn.getAttribute('data-url') || '' : '';
    const lengthPills = pdp.querySelectorAll('.viva-pdp__length-pill');
    const shadeValues = new Set(Array.from(radios, (radio) => String(radio.value)));
    const lengthValues = new Set(Array.from(lengthRadios, (radio) => String(radio.value)));
    const typeValues = new Set(Array.from(typeRadios, radio => String(radio.value)));
    const optionCount = 1 + Number(lengthValues.size > 0) + Number(typeValues.size > 0);
    const customOptionsComplete = shadeValues.size > 0
      && (highVariants || (
      variants.length === shadeValues.size * (lengthValues.size || 1) * (typeValues.size || 1)
      && variants.every((variant) => Array.isArray(variant.options)
        && variant.options.length === optionCount
        && shadeValues.has(String(variant.options[shadeIndex]))
        && (!lengthValues.size || lengthValues.has(String(variant.options[lengthIndex])))
        && (!typeValues.size || typeValues.has(String(variant.options[typeIndex]))))));
    pdp.classList.toggle('viva-pdp--custom-options', customOptionsComplete);
    pdp.classList.toggle('viva-pdp--single-variant', variants.length === 1);

    // Stash this product's context so the Try On page can show its colours, the
    // currently-selected shade, and a "back to product" button. Rewritten on every
    // shade change (via applyVariant) so it stays current.
    const ctxHandle = dataEl.getAttribute('data-pdp-handle') || '';
    const ctxUrl = dataEl.getAttribute('data-pdp-url') || '';
    const ctxTitle = dataEl.getAttribute('data-pdp-title') || '';
    const ctxShades = Array.from(radios).map((r) => r.getAttribute('data-code') || r.value);
    const writeTryonContext = (selected) => {
      if (!customOptionsComplete || !ctxHandle || !ctxShades.length) return;
      try {
        localStorage.setItem(
          'viva:tryon-context',
          JSON.stringify({ handle: ctxHandle, url: ctxUrl, title: ctxTitle, shades: ctxShades, selected: selected || '' })
        );
      } catch (error) {
        /* storage may be unavailable */
      }
    };

    let availability = variants;
    try {
      const saved = JSON.parse(pdp.querySelector('[data-pdp-availability]')?.textContent || 'null');
      if (saved && Array.isArray(saved.rows)) availability = saved.rows.map((row,i) => ({options: row.slice(0, -1), price: row.at(-1), enabled: saved.enabled?.[i] !== false}));
    } catch { /* Native prices remain usable before the first Catalog save. */ }
    const isEnabled = variant => !!variant && Number(variant.price)>0 && !availability.some(row=>row.enabled===false&&row.options.length===variant.options.length&&row.options.every((value,i)=>value===variant.options[i]));
    const normalizeChoices = () => {
      if (!window.vivaPricedChoices) return;
      const generic = Array.from(pdp.querySelectorAll('[data-pdp-option]'));
      const groups = generic.length ? generic.map(select => ({
        index: Number(select.dataset.optionPosition), value: select.value,
        values: Array.from(select.options, option => option.value), select,
      })) : [[radios,shadeIndex],[typeRadios,typeIndex],[lengthRadios,lengthIndex]]
        .filter(([inputs]) => inputs.length).map(([inputs,index]) => ({
          index, inputs: Array.from(inputs), value: Array.from(inputs).find(input => input.checked)?.value || '',
          values: Array.from(inputs, input => input.value),
        }));
      const result = window.vivaPricedChoices(availability, groups);
      groups.forEach((group,i) => {
        const {allowed,value} = result[i];
        if (group.select) {
          Array.from(group.select.options).forEach(option => { option.hidden = !allowed.includes(option.value);option.disabled = option.hidden; });
          group.select.value = value;
        } else group.inputs.forEach(input => {
          input.disabled = !allowed.includes(input.value);input.closest('label').hidden = input.disabled;input.checked = input.value === value;
        });
      });
    };

    const selectedShade = () => {
      const checked = Array.from(radios).find((r) => r.checked);
      return checked ? checked.value : null;
    };
    const selectedShadeCode = () => {
      const checked = Array.from(radios).find((r) => r.checked);
      return checked ? checked.getAttribute('data-code') || checked.value : null;
    };
    const selectedShadeLabel = () => {
      const checked = Array.from(radios).find((r) => r.checked);
      return checked ? checked.getAttribute('data-label') || checked.value : null;
    };
    const selectedLength = () => {
      const checked = Array.from(lengthRadios).find((r) => r.checked);
      return checked ? checked.value : null;
    };

    let formatter = null;
    try {
      formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency });
    } catch (error) {
      formatter = null;
    }

    const formatPrice = (cents) => {
      if (!cents || cents <= 0) return dataEl.dataset.pdpMissingLabel || '';
      const amount = cents / 100;
      return formatter ? formatter.format(amount) : amount.toFixed(2);
    };

    const applyVariant = (variant) => {
      pdp.dispatchEvent(new CustomEvent('viva:variant-media', {detail: {id: variant?.id || null}}));
      if (!isEnabled(variant)) {
        if (idInput) idInput.value = '';
        if (askBtn) askBtn.hidden = true;
        if (addBtn) addBtn.disabled = true;
        if (priceEl) priceEl.textContent = dataEl.dataset.pdpMissingLabel || '';
        if (selectionStatus) { selectionStatus.hidden = false;selectionStatus.textContent = dataEl.dataset.pdpMissingLabel || ''; }
        return;
      }
      if (askBtn) askBtn.hidden = dataEl.dataset.pdpCommerceEnabled === 'true' && variant.available;
      applyVariantImage(variant);
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatPrice(variant.price);
      if (currentLabel) currentLabel.textContent = selectedShadeLabel() || variant.option1 || variant.title;
      if (lengthLabel) lengthLabel.textContent = variant.options[lengthIndex] || '';
      if (typeLabel) typeLabel.textContent = variant.options[typeIndex] || '';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available ? dataEl.getAttribute('data-pdp-add-label') || '' : dataEl.getAttribute('data-pdp-unavailable-label') || '';
        }
      }
      if (favBtn) {
        const sep = favBase.indexOf('?') === -1 ? '?' : '&';
        favBtn.setAttribute('data-url', favBase ? favBase + sep + 'variant=' + variant.id : '');
        const variantTitle = variant.options.length === 1 && variant.option1 === 'Default Title'
          ? '' : variant.options.join(' · ');
        favBtn.setAttribute('data-variant-title', variantTitle);
        favBtn.setAttribute('data-price', formatPrice(variant.price));
      }
      writeTryonContext(selectedShadeCode());
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    let selectionRequest = 0;
    let selectionAbort;
    const sync = async () => {
      normalizeChoices();
      const shade = selectedShade();
      const length = selectedLength();
      const type = Array.from(typeRadios).find(radio => radio.checked)?.value;
      let variant;
      if (highVariants) {
        const requestId = ++selectionRequest;
        selectionAbort?.abort();
        selectionAbort = new AbortController();
        const inputs = [...radios, ...lengthRadios, ...typeRadios].filter(input => input.checked);
        const values = inputs.map(input => input.dataset.optionValueId);
        if (addBtn) addBtn.disabled = true;
        if (priceEl) priceEl.textContent = dataEl.dataset.pdpLoadingLabel || '';
        if (selectionStatus) { selectionStatus.hidden = false; selectionStatus.textContent = dataEl.dataset.pdpLoadingLabel; }
        try {
          if (values.length !== optionCount || values.some(value => !value)) { applyVariant(null);return; }
          const url = new URL(window.location.href);
          url.searchParams.delete('variant');
          url.searchParams.set('section_id', pdp.dataset.sectionId);
          url.searchParams.set('option_values', values.join(','));
          const response = await fetch(url, {signal: selectionAbort.signal});
          if (!response.ok) throw new Error('Variant request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          variant = JSON.parse(html.querySelector('[data-pdp-selected-variant]').textContent);
          if (requestId !== selectionRequest) return;
          if (variant && !isEnabled(variant)) variant = null;
          if (variant && !inputs.every(input => variant.options.includes(input.value))) variant = null;
          if (!variant) {
            if (selectionStatus) selectionStatus.textContent = dataEl.dataset.pdpMissingLabel;
            if (idInput) idInput.value = '';
            return;
          }
          if (idInput && !Array.from(idInput.options).some(option => String(option.value) === String(variant.id))) {
            idInput.add(new Option(variant.title, String(variant.id)));
          }
          if (selectionStatus) selectionStatus.hidden = true;
        } catch (error) {
          if (error.name === 'AbortError' || requestId !== selectionRequest) return;
          if (priceEl) priceEl.textContent = dataEl.dataset.pdpErrorLabel || '';
          if (selectionStatus) selectionStatus.textContent = dataEl.dataset.pdpErrorLabel;
          return;
        }
      } else {
        variant = variants.find(item => String(item.options[shadeIndex]) === String(shade)
          && (!lengthRadios.length || String(item.options[lengthIndex]) === String(length))
          && (!typeRadios.length || String(item.options[typeIndex]) === String(type)));
      }
      swatches.forEach((swatch) => {
        const input = swatch.querySelector('[data-pdp-shade]');
        swatch.classList.toggle('is-active', !!input && input.checked);
      });
      lengthPills.forEach((pill) => {
        const input = pill.querySelector('[data-pdp-length], [data-pdp-type]');
        pill.classList.toggle('is-active', !!input && input.checked);
      });
      applyVariant(variant);
    };

    const genericOptions = Array.from(pdp.querySelectorAll('[data-pdp-option]'));
    if (genericOptions.length) {
      pdp.classList.add('viva-pdp--generic-options');
      const syncGeneric = async () => {
        normalizeChoices();
        const requestId = ++selectionRequest;
        selectionAbort?.abort();
        const choices = genericOptions.map(select => select.value);
        let variant = variants.find(v => v.options.every((value, index) => value === choices[index]));
        if (selectionStatus) { selectionStatus.hidden = false; selectionStatus.textContent = dataEl.dataset.pdpLoadingLabel; }
        if (addBtn) addBtn.disabled = true;
        try {
          if (highVariants) {
            selectionAbort = new AbortController();
            const values = genericOptions.map(select => select.selectedOptions[0]?.dataset.optionValueId);
            if (values.some(value => !value)) throw new Error('Missing option value');
            const url = new URL(window.location.href);
            url.searchParams.delete('variant');
            url.searchParams.set('section_id', pdp.dataset.sectionId);
            url.searchParams.set('option_values', values.join(','));
            const response = await fetch(url, {signal: selectionAbort.signal});
            if (!response.ok) throw new Error('Variant request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            variant = JSON.parse(html.querySelector('[data-pdp-selected-variant]').textContent);
          }
          if (requestId !== selectionRequest) return;
          if (!isEnabled(variant) || !variant.options.every((value, index) => value === choices[index])) {
            if (selectionStatus) selectionStatus.textContent = dataEl.dataset.pdpMissingLabel;
            if (idInput) idInput.value = '';
            return;
          }
          if (idInput && !Array.from(idInput.options).some(option => String(option.value) === String(variant.id))) {
            idInput.add(new Option(variant.title, String(variant.id)));
          }
          if (selectionStatus) selectionStatus.hidden = true;
          applyVariant(variant);
        } catch (error) {
          if (error.name === 'AbortError' || requestId !== selectionRequest) return;
          if (priceEl) priceEl.textContent = dataEl.dataset.pdpErrorLabel || '';
          if (selectionStatus) selectionStatus.textContent = dataEl.dataset.pdpErrorLabel;
        }
      };
      genericOptions.forEach(select => select.addEventListener('change', syncGeneric));
      syncGeneric();
      return;
    }

    if (!customOptionsComplete) {
      const applySelectedVariant = () => {
        const selected = variants.find((variant) => String(variant.id) === String(idInput.value));
        applyVariant(selected);
      };
      if (idInput) {
        idInput.addEventListener('change', applySelectedVariant);
        applySelectedVariant();
      }
      return;
    }

    radios.forEach((radio) => radio.addEventListener('change', sync));
    lengthRadios.forEach((radio) => radio.addEventListener('change', sync));
    typeRadios.forEach((radio) => radio.addEventListener('change', sync));

    // Pre-select a shade carried over from the Try On flow (?odcien=… or localStorage).
    const desiredShade = (() => {
      try {
        const fromUrl = new URL(window.location.href).searchParams.get('odcien');
        return fromUrl || localStorage.getItem('viva:selected-odcien');
      } catch (error) {
        return null;
      }
    })();
    if (desiredShade) {
      try {
        localStorage.removeItem('viva:selected-odcien');
      } catch (error) {
        /* ignore */
      }
      const match = Array.from(radios).find((r) => String(r.getAttribute('data-code') || r.value) === String(desiredShade));
      if (match && !match.checked) {
        match.checked = true;
      }
    }

    // Initialise variant id, price and the favourite snapshot from the current selection.
    sync();
  });
};
document.addEventListener('DOMContentLoaded', initVivaProducts);
document.addEventListener('shopify:section:load', initVivaProducts);
